import {GET_EVENTS_ERROR, GET_EVENTS_START, GET_EVENTS_SUCCESS} from "../../types";

export default function events(state, action) {
  switch (action.type) {
    case GET_EVENTS_START:
      return {
        ...state,
        data: [],
        loading: true,
        error: null
      };
    case GET_EVENTS_SUCCESS:
      return {
        ...state,
        data: action.results,
        loading: false,
        error: null
      };
    case GET_EVENTS_ERROR:
      return {
        ...state,
        data: [],
        loading: false,
        error: action.detail
      };
    default:
      return {...state};
  }
}
